import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Lot } from '../components/bids-and-offers/lots.model';
import { Apollo, gql } from 'apollo-angular';

const RemoveLot = gql`
  mutation RemoveLot($id: String!) {
    removeLot(id: $id) {
      _id
      user_id
      commodity
      product_type
      grade
      createdAt
      updatedAt
      user_id
      lot_type
      deletedAt
    }
  }
`;

const EditLot = gql`
  mutation UpdateLot($updateLotId: String!, $updateLotInput: UpdateLotInput!) {
    updateLot(id: $updateLotId, updateLotInput: $updateLotInput) {
      _id
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LotDataService {
  private lotSource = new BehaviorSubject<Lot[]>([]);
  currentLot = this.lotSource.asObservable();

  constructor(private apollo: Apollo) {}

  addLot(newLot: Lot) {
    const newLotWithCreatedAt = {
      ...newLot,
      createdAt: new Date(), // This adds the current date and time
    };
    const currentLots = this.lotSource.getValue();
    this.lotSource.next([newLotWithCreatedAt, ...currentLots]);
  }

  removeLot(lotId: string) {
    return this.apollo.mutate({
      mutation: RemoveLot,
      variables: {
        id: lotId,
      },
    });
  }

  editLot(lotId, value) {
    return this.apollo.mutate({
      mutation: EditLot,
      variables: {
        updateLotId: lotId,
        updateLotInput: value,
      },
    });
  }
}
